import Settings from 'src/Settings';
import RedesignDescriptor from './app-tour-redesign';
import RefiveDescriptor from './app-tour-refive';
import CanteenDescriptor from './app-tour-canteen';
import CompanyKitchenDescriptor from './app-tour-companykitchen';
import AramarkDescriptor from './app-tour-aramark';
import {BuildTypeEnum} from '../../../../constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
  [BuildTypeEnum.canteen]: CanteenDescriptor,
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
};

export function getAppTourDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}
